var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DangerZone',{attrs:{"dangerZoneTitle":_vm.deleteHeaderText,"confirmationTitle":_vm.confirmationTitle,"confirmationText":_vm.confirmationText,"dangerZoneText":_vm.deleteBodyText,"handleConfirmation":_vm.handleDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }